import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-specialization-modal',
  templateUrl: './specialization-modal.component.html',
  styleUrls: ['./specialization-modal.component.scss']
})
export class SpecializationModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  specials = null;
  mode = null;
  data = null
  Success = null

  stateForm = new FormGroup({
    Spec_Name: new FormControl('', Validators.required),
    Spec_Id: new FormControl(null, Validators.required),
    Status_Spec: new FormControl('', Validators.required),
    Author_Id: new FormControl(0, Validators.required),
    Entry_Date: new FormControl(new Date().toISOString(), Validators.required),
  });

  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      Spec_Name,
      Spec_Id,
      Status_Spec,
      Author_Id,
      Entry_Date,
    } = this.stateForm.value;
    this.auth
      .postSpecials(
        Spec_Name,
        Spec_Id,
        Status_Spec,
        Author_Id,
        Entry_Date,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess)

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });           }
          else {
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
      .getSpecials()
      .subscribe(
        (resSuccess) => {

          this.specials = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

  addNew() {
    this.mode = "add"
  }
  edit(special) {
    this.mode = "edit"
    this.stateForm.patchValue({
      Spec_Name: special.Spec_Name,
      Spec_Id: special.Spec_Id,
      Status_Spec: special.Status_Spec,
      Author_Id: special.Author_Id,
      Entry_Date: special.Entry_Date,
    });
    console.log(this.stateForm.value)
  }

  delete(title) {
    this.auth
      .delSet("/api/specializations/deleteSpecialization", title.Spec_Id)
      .subscribe(
        (resSuccess) => {
          this.specials = this.specials.filter(dattum => dattum.Spec_Id !== title.Spec_Id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
